<div id="table_objects_stat" class="tablewrap resizetable tabpage hidden">
    <div class="table tableinfo">
      <table fixedcols="[]" id="objectsstattable">
        <tr>
          <th  class="object_column">{{'Object'|translate }}</th>
          <th class="time_column">{{'Moving'|translate }}</th>
          <th class="time_column">{{'Parking'|translate }}</th>
          <th>{{'Mileage'|translate }}</th>
          <th>{{'Avg. speed'|translate }}</th>
          <th>{{'Max. speed'|translate }}</th>
          <th>{{'Engine time'|translate }}</th>
          <th>{{'Idling'|translate }}</th>
          <th>{{'Fuel consumption'|translate }}</th>
        </tr>
      </table>
    </div>
    <app-pagination [viewmode]="'print excel'" [printElementID]="'objectsstattable'"></app-pagination>
</div>
